<template>
  <div class="outer-box max-w-xl">
    <h4>Move Agency Out of LC Phone</h4>

    <b-alert show variant="danger" class="text-left m-3">
      Before disabling ISV, please notify the agency owner. Then, use the relationship number to
      move the agency out of ISV mode.
    </b-alert>

    <div class="inner-box" style="text-align: left; width: 500px">
      <div>Relationship Number</div>
      <input
        class="hl_input--wrap"
        type="text"
        placeholder="Relationship Number"
        v-model="relationshipNumber"
      />
      <br />
      <br />
      <button
        :disabled="disabled || processing"
        class="btn btn-danger mt-4"
        @click="disableISVForAgency"
      >
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else>Disable Agency ISV</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { SaasService } from "@/services";

export default {
  data() {
    return {
      relationshipNumber: "",
      processing: false,
      response: null,
    };
  },
  computed: {
    disabled() {
      if (!this.relationshipNumber) return true;
      else return false;
    },
  },
  methods: {
    disableISVForAgency() {
      this.processing = true;
      SaasService.moveCompanyOutOfISV(this.relationshipNumber)
        .then((response) => {
          this.response = response.data;
        })
        .catch((error) => {
          this.response = error.response.data;
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>

<style></style>
